module.exports = __webpack_public_path__ + "static/travel-dbf5d23dbf784be8d54d0d2e4ff38cc7.mp4";